import React from "react"
import Main from "./components/Main/Main"
import ToDesigners from "./components/ToDesigners/ToDesigners"
import WhyMatters from "./components/WhyMatters/WhyMatters"
import Bonuses from "./components/Bonuse/Bonuses"
import WhyUs from "./components/WhyUs/WhyUs"
import FrequentQuestions from "./components/FrequentQuestions/FrequentQuestions"
import Order from "./components/Order/Order"
import CompletedProjects from "./components/CompletedProjects/CompletedProjects"

function App() {
  return (
    <div className="App">
      <Main />
      <ToDesigners />
      <WhyMatters />
      <Bonuses />
      <WhyUs />
      <FrequentQuestions />
      <Order />
      <CompletedProjects />
    </div>
  )
}

export default App
